import { render, staticRenderFns } from "./BtnRestartBySchoolCycleGrade.vue?vue&type=template&id=62ad1a29"
import script from "./BtnRestartBySchoolCycleGrade.vue?vue&type=script&lang=js"
export * from "./BtnRestartBySchoolCycleGrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports